import Vue from "vue";

let empDownloadHudAutoCloseTimer = null;

function clearEmpDownloadHudAutoCloseTimer() {
  if (empDownloadHudAutoCloseTimer != null) {
    clearTimeout(empDownloadHudAutoCloseTimer);
    empDownloadHudAutoCloseTimer = null;
  }
}

/**
 * 全局右下角「下載 / 導出」進度 Toast（與 EmpDownloadStatusToast 配套）。
 * 任意頁可調用 Vue.prototype.$empDownloadHud.show({ title, subtitle, contextLabel, variant, autoCloseMs })。
 * autoCloseMs：可選，>0 時在該毫秒後自動 hide（與手動點 X 互斥時會一併清除計時器）。
 * 操作日誌導出仍由 oplogExportHud 驅動，EmpDownloadHudHost 內會優先展示操作日誌狀態。
 */
export const empDownloadHud = Vue.observable({
  visible: false,
  variant: "progress",
  title: "",
  subtitle: "",
  contextLabel: "",
  /** manual：業務直接填文案；與操作日誌 Toast 並存時以操作日誌為優先 */
  mode: null,
});

export function empDownloadHudOpen({
  variant = "progress",
  title = "",
  subtitle = "",
  contextLabel = "",
  autoCloseMs = null,
} = {}) {
  clearEmpDownloadHudAutoCloseTimer();
  empDownloadHud.mode = "manual";
  empDownloadHud.visible = true;
  empDownloadHud.variant = variant === "error" ? "error" : "progress";
  empDownloadHud.title = typeof title === "string" ? title : "";
  empDownloadHud.subtitle = typeof subtitle === "string" ? subtitle : "";
  empDownloadHud.contextLabel = typeof contextLabel === "string" ? contextLabel.trim() : "";
  const ms = Number(autoCloseMs);
  if (Number.isFinite(ms) && ms > 0) {
    empDownloadHudAutoCloseTimer = setTimeout(() => {
      empDownloadHudAutoCloseTimer = null;
      empDownloadHudClose();
    }, ms);
  }
}

export function empDownloadHudClose() {
  clearEmpDownloadHudAutoCloseTimer();
  empDownloadHud.visible = false;
  empDownloadHud.mode = null;
  empDownloadHud.title = "";
  empDownloadHud.subtitle = "";
  empDownloadHud.contextLabel = "";
}
